module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/ttd_logo.73f8655.png";